import { render, staticRenderFns } from "./TituloRetornar.vue?vue&type=template&id=0c3ed6a2&"
import script from "./TituloRetornar.vue?vue&type=script&lang=js&"
export * from "./TituloRetornar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports